import Button from '../ui/Button'
import { useLang } from '../../contexts/LangContext'

interface OnboardingCompleteProps {
  onGoToDashboard: () => void
}

export default function OnboardingComplete({ onGoToDashboard }: OnboardingCompleteProps) {
  const { t } = useLang()

  return (
    <div className="rounded-[2rem] border border-emerald-200 bg-[linear-gradient(140deg,#ecfdf5_0%,#d1fae5_52%,#f8fafc_100%)] p-8 text-center shadow-sm">
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500 text-4xl text-white shadow-lg shadow-emerald-200">
        ✓
      </div>
      <p className="mt-6 text-xs font-semibold uppercase tracking-[0.24em] text-emerald-700">
        {t('Έτοιμο', 'Ready')}
      </p>
      <h2 className="mt-3 text-3xl font-black tracking-tight text-slate-950">
        {t('Είσαι έτοιμος να ξεκινήσεις', 'You are all set')}
      </h2>
      <p className="mx-auto mt-4 max-w-2xl text-base leading-8 text-slate-700">
        {t(
          'Το προφίλ σου είναι πλέον έτοιμο και ορατό στους πελάτες. Από εδώ και πέρα μπορείς να οργανώσεις κρατήσεις και να βελτιώνεις το προφίλ σου από το dashboard.',
          'Your profile is now ready and visible to customers. From here you can manage bookings and keep refining your profile from the dashboard.',
        )}
      </p>
      <div className="mt-8">
        <Button type="button" size="lg" onClick={onGoToDashboard}>
          {t('Μετάβαση στο dashboard', 'Go to dashboard')}
        </Button>
      </div>
    </div>
  )
}
